export const AccessDeniedQueryParam = {
  reason: 'reason',
} as const;

export const AccessDeniedReason = {
  Sso: 'sso',
} as const;

export const AccessDeniedConstants = {
  ssoNoAccessTitle: 'No Access to Rehab Connect',
  ssoNoAccessMessage:
    "This account doesn't have access to Rehab Connect. If you have a different login for Rehab Connect, try that account, or contact your administrator for access.",
  tryDifferentAccount: 'Try a different account',
  logoutConfirmTitle: 'Log out of myzPAX?',
  logoutConfirmMessage:
    'Your myzPAX session is currently active. Continuing will log you out of myzPAX so you can sign back in with a different account.',
  logoutConfirmButtonText: 'Log out and continue',
  logoutConfirmCancelText: 'Cancel',
};
